import React from 'react';
import { Link } from 'react-router-dom';
// Components
import Logo from '../Logo';
// Image
import TMDBLogo from '../../images/tmdb_logo.svg';
// Styles
import { Wrapper, Content, Marquee, Bottom, Credit } from './Footer.styles';

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const Footer = () => (
  <Wrapper>
    <Marquee aria-hidden='true'>
      {LETTERS.map(letter => (
        <span key={letter}>{letter}</span>
      ))}
    </Marquee>
    <Content>
      <Link to='/' aria-label='A to Z Movie Database — home'>
        <Logo inverted />
      </Link>
      <p>
        Every film, from <em>A</em> to <em>Z</em>. Browse what’s popular,
        search any title, and dig into the cast, crew and box office behind it.
      </p>
      <a
        href='https://www.themoviedb.org/'
        target='_blank'
        rel='noreferrer'
        className='tmdb'
      >
        <img src={TMDBLogo} alt='Powered by The Movie Database (TMDB)' />
      </a>
    </Content>
    <Bottom>
      <span>© {new Date().getFullYear()} A to Z Movie Database</span>
      <span>
        This product uses the TMDB API but is not endorsed or certified by TMDB.
      </span>
      <Credit
        href='https://azel.studio'
        target='_blank'
        rel='noreferrer'
        aria-label='Designed and built by Azel Studio (opens in a new tab)'
      >
        <span className='label'>Crafted by</span>
        <span className='name'>Azel Studio</span>
        <span className='arrow' aria-hidden='true'>↗</span>
      </Credit>
    </Bottom>
  </Wrapper>
);

export default Footer;
